import { SidePanelId } from 'src/constants'
import { useRoomTableStore, useSidePanelStore } from 'src/hooks/stores'
import { useSidePanelLayout } from 'src/hooks/useSidePanelLayout'
import { SidePanelState } from 'src/types'

export const useSidePanel = () => {
  const { sidePanelStoreValue, setSidePanelStoreValue } = useSidePanelStore()
  const { resetSelectedCell } = useRoomTableStore()
  const { showSidePanel, hideSidePanel } = useSidePanelLayout()

  const openSidePanel = (state: SidePanelState) => {
    setSidePanelStoreValue(previous => {
      return {
        ...previous,
        state,
      }
    })
    showSidePanel()

    // NOTE: セル選択の解除はコンポートのuseEffectを使って呼び出すと画面描画がとても遅くなってしまうため分かりづらさを持ってしまうがここで呼び出す
    // 住戸のセル選択を許容するサイドパネルの種類。それ以外の場合は選択を解除する
    const enableSelectedCellStateKeys = [
      'selectMasterDetail',
      'selectMasterDetailWithRoomId',
      'selectMasterDetailWithLockedRoomId',
      'applicationDetail',
      'contractorDetail',
      'contractorHistories',
    ]
    !enableSelectedCellStateKeys.includes(state.key) && resetSelectedCell()
  }
  const closeSidePanel = () => {
    setSidePanelStoreValue(previous => ({
      ...previous,
      state: null,
    }))
    hideSidePanel()
    resetSelectedCell()
  }

  const hasSidePanel = (target: EventTarget) => {
    let targetElement = target as HTMLElement

    while (targetElement) {
      if (targetElement.id === SidePanelId) {
        return true
      }
      targetElement = targetElement.parentNode as HTMLElement
    }
    return false
  }

  return {
    sidePanelState: sidePanelStoreValue.state,
    openSidePanel,
    closeSidePanel,
    hasSidePanel,
  }
}
